/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import {
  getSOCancellationDetailsSuccess,
  getSOCancellationDetailsFailure,
  GetSOCancellationDetailsAction,
  GetSOCancellationDetailsActionTypes,
} from '../actions/GetSOCancellationDetails';
import getSOCancellationDetailsService from '../services/GetSOCancellationDetails';
import { IErrorActionData } from '../../../models/Error';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';

const GetSOCancellationDetailsEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(GetSOCancellationDetailsActionTypes.GET_SO_CANCELLATION_DETAILS)),
  mergeMap((action: GetSOCancellationDetailsAction) => from(
    getSOCancellationDetailsService(action.payload.filter),
  ).pipe(
    map((response) => getSOCancellationDetailsSuccess({
      cancellationSODetails: response.data.getSOCancellationDetails.data.supplyOrderDetails || [],
    })),
    catchError((error: IErrorActionData) => of(
      getSOCancellationDetailsFailure({
        errorCode: error.errorCode || 500,
        errorMessage: error.errorMessage,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default GetSOCancellationDetailsEpic;
